/** Remove identifiers and experiment assignments when analytics is disabled. */
export function clearAnalyticsStorage(win = globalThis.window, storage = null) {
  let qa = false;
  try { qa = (storage || win?.localStorage)?.getItem("bq_qa") === "1" || /(?:^|;\s*)bq_qa=1(?:;|$)/.test(String(win?.document?.cookie || "")); } catch { /* unavailable */ }
  for (const get of [() => storage || win?.localStorage, () => win?.sessionStorage]) {
    try {
      const store = get();
      const keys = [];
      for (let i = 0; i < (store?.length || 0); i += 1) keys.push(store.key(i));
      for (const key of keys) {
        if (key === "barumba.anon" || key === "barumba.ga_internal" || (key?.startsWith("barumba.exp.") && !(qa && key === "barumba.exp.qa"))) {
          try { store.removeItem(key); } catch { /* blocked */ }
        }
      }
    } catch { /* blocked */ }
  }
}

export function analyticsAllowed({ nav, storage, requiresConsent = globalThis.window?.__barumbaConfig?.requiresConsent === true, win = globalThis.window } = {}) {
  let choice = null;
  try { choice = storage?.getItem("barumba.consent.analytics"); } catch { /* no choice */ }
  const pending = win?.__barumbaConsentPending === true;
  const allowed = nav?.globalPrivacyControl !== true && choice !== "denied" && !pending && !win?.__barumbaGaTcfDenied && (!requiresConsent || choice === "granted");
  if (!allowed && (!pending || choice === "denied" || nav?.globalPrivacyControl === true)) clearAnalyticsStorage(win, storage);
  return allowed;
}
